import { Component, OnInit, Input, ElementRef, Renderer2 } from "@angular/core";
import { StudentMaster } from "../model/StudentMaster.model";
import { AuthService } from "../service/auth.service";
import { HttpErrorResponse } from "@angular/common/http";
import { User } from "../model/User.model";
import { SessionClient } from "../configration/sessionclient.storage";
import { Router } from "@angular/router";
import { MainserviceService } from "../service/mainservice.service";
import { PredefinedMaster } from "../model/PredefinedMaster.model";
import Swal from "sweetalert2";
import { CourseMaster } from "../model/CourseMaster.model";
import $ from "jquery";
import { nullSafeIsEquivalent } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  activeState: boolean = false;
  activeStateTemp: boolean = false;

  displayregister: boolean = false;
  displaylogin: boolean = false;
  studentMaster: StudentMaster = new StudentMaster();
  user: User = new User();
  displayforgotpassword: boolean = false;
  forgotpasswordotp: string;
  displayforgotpasswordotp: boolean = false;
  openforgetpassword: boolean = false;
  displayforgotpasswordsave: boolean = false;
  displayregisterotp: boolean = false;
  registerOTP: string;
  enterregisterOTP: string;
  otpget: string;
  getForgotOtp: string;
  predefineMaster: PredefinedMaster = new PredefinedMaster();
  CityList: PredefinedMaster[] = [];
  stateList: PredefinedMaster[] = [];
  openprofile: boolean = false;
  errorMessage: String;
  userSession: User = new User();
  studentSession: StudentMaster = new StudentMaster();
  buttonSession: any;

  courseMaster: CourseMaster = new CourseMaster();
  DesiredCourseList: CourseMaster[] = [];
  passwordconfirms: boolean = false;
  status: boolean = false;
  confirmStatus: boolean = false;
  confirmpasswordconfirms: boolean = false;
  LoginStatus: boolean = false;
  loginPassword: boolean = false;
  forgotPass: boolean = false;
  forgotStatus: boolean = false;
  forgotConfirmPass: boolean = false;
  forgotConfirmStatus: boolean = false;
  maxDate: Date;
  studentMasterSession: StudentMaster = new StudentMaster();
  displayModal:boolean=false;
  displayDeleteAccount:boolean=false;
  constructor(
    private authService: AuthService,
    private sessionClient: SessionClient,
    private router: Router,
    private mainService: MainserviceService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    // this.getCityList();
    // this.getDesiredCourse();
    this.studentSession = this.authService.getUserSession();
    this.studentMasterSession = this.authService.getUserSession();

    $(document).ready(function () {
      $(".navbar-toggler").click(function () {
        $(this).toggleClass("collapsed");
        $(".navbar-collapse").toggleClass("show");
      });
    });
    let today = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(today.getDate() - 1);
    // this.studentMaster =this.mainService.getstudentSession();
  }
  showRegisterDialog() {
    this.studentMaster = new StudentMaster();
    this.displayregister = true;

    this.getStateList();
    this.getDesiredCourse();
    this.displaylogin = false;
  }
  displayloginDialog() {
    this.user = new User();
    this.displaylogin = true;
    this.displayregister = false;
  }
  forgotPasswordDialog() {
    this.displayforgotpassword = true;
    this.displaylogin = false;
  }
  showProfileDialog() {
    this.openprofile = true;
  }
  closeprofile() {
    this.openprofile = false;
  }
  checkDuplicateMobileno() {
    this.user.phone = this.studentMaster.contactNo;
    this.user.email = this.studentMaster.email;
    this.user.referralCode = this.studentMaster.referralCode;
    if (this.studentMaster.password != this.studentMaster.confirmPassword) {
      return;
    }
    if (
      this.studentMaster.name === undefined ||
      this.studentMaster.name === null ||
      this.studentMaster.name === ""
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Your Name Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }

    if (
      this.studentMaster.studentName === undefined ||
      this.studentMaster.studentName === null ||
      this.studentMaster.studentName === ""
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Student Name Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.contactNo === undefined ||
      this.studentMaster.contactNo === null
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Contact Number Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.email === undefined ||
      this.studentMaster.email === null ||
      this.studentMaster.email === ""
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Email Id Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.password === undefined ||
      this.studentMaster.password === null ||
      this.studentMaster.password === ""
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Password Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.confirmPassword === undefined ||
      this.studentMaster.confirmPassword === null ||
      this.studentMaster.confirmPassword === ""
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Confirm Password Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.location === undefined ||
      this.studentMaster.location === null
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Location Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.desiredCourseMaster === undefined ||
      this.studentMaster.desiredCourseMaster === null
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Desired Course Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    if (
      this.studentMaster.studentDob === undefined ||
      this.studentMaster.studentDob === null
    ) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Date Of Birth Required!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }
    let regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (!regexp.test(this.studentMaster.email)) {
      {
        // Swal.fire({
        //   title: 'Error',
        //   text: 'Invalid Email Format!',
        //   icon: 'error',
        //   showCancelButton: true,
        //   showConfirmButton: true,
        // })
        return;
      }
    }

    this.authService.checkDuplicateEmailAndMobileNo(this.user).subscribe(
      (data) => {
        if (data.errorMessage === "NO-DUP") {
          this.sendRegisterOTP();
        } else if (data.errorMessage === "INVALID-EMAIL") {
          // Swal.fire({
          //   title: 'Error',
          //   text: 'Enter Valid Email Id!',
          //   icon: 'error',
          //   showCancelButton: true,
          //   showConfirmButton: true,
          // })
        } else if (data.errorMessage === "DUP-USERNAME") {
          // Swal.fire({
          //   title: 'Error',
          //   text: 'UserName Already Used!',
          //   icon: 'error',
          //   showCancelButton: true,
          //   showConfirmButton: true,
          // })
        } else if (data.errorMessage === "DUP-PHONE") {
          // Swal.fire({
          //   title: 'Error',
          //   text: 'Duplicate Mobile Number!',
          //   icon: 'error',
          //   showCancelButton: true,
          //   showConfirmButton: true,
          // })
        } else if (data.errorMessage === "INVALID-PHONE") {
          // alert(" Invalid mobile number");
          // Swal.fire({
          //   title: 'Error',
          //   text: 'Invalid Mobile Number!',
          //   icon: 'error',
          //   showCancelButton: true,
          //   showConfirmButton: true,
          // })
        } else if (data.errorMessage === "DUP-EMAIL") {
          // alert("Duplicate  email");
          // Swal.fire({
          //   title: 'Error',
          //   text: 'Duplicate Email Id!',
          //   icon: 'error',
          //   showCancelButton: true,
          //   showConfirmButton: true,
          // })
        } else if (data.errorMessage === "INVALID-REFERREL-CODE") {
          // alert("Duplicate  email");
          // Swal.fire({
          //   title: 'Error',
          //   text: 'Invalid Refferal Code!',
          //   icon: 'error',
          //   showCancelButton: true,
          //   showConfirmButton: true,
          // })
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;
          if (jsonString === "NO-DUP") {
            this.sendRegisterOTP();
          } else if (jsonString === "INVALID-EMAIL") {
            // Swal.fire({
            //   title: 'Error',
            //   text: 'Enter Valid Email Id!',
            //   icon: 'error',
            //   showCancelButton: true,
            //   showConfirmButton: true,
            // })
          } else if (jsonString === "DUP-PHONE") {
            // Swal.fire({
            //   title: 'Error',
            //   text: 'Duplicate Mobile Number!',
            //   icon: 'error',
            //   showCancelButton: true,
            //   showConfirmButton: true,
            // })
          } else if (jsonString === "INVALID-PHONE") {
            // alert(" Invalid mobile number");
            // Swal.fire({
            //   title: 'Error',
            //   text: 'Invalid Mobile Number!',
            //   icon: 'error',
            //   showCancelButton: true,
            //   showConfirmButton: true,
            // })
          } else if (jsonString === "DUP-EMAIL") {
            // alert("Duplicate  email");
            // Swal.fire({
            //   title: 'Error',
            //   text: 'Duplicate Email Id!',
            //   icon: 'error',
            //   showCancelButton: true,
            //   showConfirmButton: true,
            // })
          } else if (jsonString === "DUP-USERNAME") {
            // Swal.fire({
            //   title: 'Error',
            //   text: 'UserName Already Used!',
            //   icon: 'error',
            //   showCancelButton: true,
            //   showConfirmButton: true,
            // })
          } else if (jsonString === "INVALID-REFERREL-CODE") {
            // alert("Duplicate  email");
            // Swal.fire({
            //   title: 'Error',
            //   text: 'Invalid Refferal Code!',
            //   icon: 'error',
            //   showCancelButton: true,
            //   showConfirmButton: true,
            // })
          }
          //json circular break at server side always add
          //extra information of timestamp and status along with
          //main json so parsing occurs still at status 200

          //  this.redirection();
        }
      }
    );
  }

  open() {
    this.activeState = true;
  }
  close() {
    console.log("CLOSE");

    this.activeState = false;
    this.activeStateTemp = false;
    setTimeout(() => {
      document.getElementById("absbtn").style.display = "block";
    }, 200);
  }

  searchPage() {
    this.router.navigateByUrl("/search-results");
  }

  openDropdown() {
    this.activeStateTemp = true;
    document.getElementById("absbtn").style.display = "none";
  }

  closeDropdown() {
    this.activeStateTemp = false;
  }

  sendRegisterOTP() {
    this.displayregisterotp = true;
    this.displayregister = false;
    this.user.isNewRegistration = true;

    this.user.phone = this.studentMaster.contactNo;
    this.authService.sendOtpToUser(this.user).subscribe(
      (data) => {
        this.otpget = data;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;
          // alert(jsonString);

          // if(jsonString == "SUCCESS"){
          //   Swal.fire({
          //     title: 'Success',
          //     text: 'SuccessFully Registered!',
          //     icon: 'success',
          //     showCancelButton: true,
          //     showConfirmButton: true,
          //   })
          // }

          //json circular break at server side always add
          //extra information of timestamp and status along with
          //main json so parsing occurs still at status 200

          //  this.redirection();
        }
      }
    );
  }

  getSelectedcityList() {
    this.getCityList();
  }
  getCityList() {
    this.predefineMaster.entityType = "LOCATION";
    this.predefineMaster.subName = this.studentMaster.state.subName;
    this.mainService
      .getPredefinedByTypeAndSubName(this.predefineMaster)
      .subscribe((data) => {
        this.CityList = data;
      });
  }
  getStateList() {
    this.predefineMaster.entityType = "LOCATION";

    this.mainService
      .getPredefinedListByTypeDistinctSubName(this.predefineMaster)
      .subscribe((data) => {
        this.stateList = data;
      });
  }
  getDesiredCourse() {
    this.courseMaster.isDeactive = "N";
    this.mainService
      .getDesiredCourseMasterList(this.courseMaster)
      .subscribe((data) => {
        this.DesiredCourseList = data;
      });
  }
  Logoutuser(){
    localStorage.removeItem("userSession");
    // localStorage.removeItem('properties');
    localStorage.removeItem("studentMaster");
    // localStorage.removeItem('courseMasterSession');
    // localStorage.removeItem('accessControlMapData');
    //   localStorage.removeItem('accessControlListData');

    // this.authService.employeeMaster = new EmployeeMaster();
    this.sessionClient.signOut();
    this.router.navigateByUrl("/");

    setTimeout(() => {
      //<<<---    using ()=> syntax
      window.location.reload();
    }, 500);
  }
  public logout() {
  
      this.displayModal=true;
    this.activeStateTemp = false;
    this.activeState=false;
    console.log("kk")
    // this.close();
   
       

        // this.router.navigateByUrl('/');
   
  }
  togglePassword() {
    if (this.passwordconfirms) {
      this.passwordconfirms = false;
    } else {
      this.passwordconfirms = true;
    }
  }
  clickEvent() {
    this.status = !this.status;
  }

  toggleconfrimPass() {
    if (this.confirmpasswordconfirms) {
      this.confirmpasswordconfirms = false;
    } else {
      this.confirmpasswordconfirms = true;
    }
  }
  confirmclickEvent() {
    this.confirmStatus = !this.confirmStatus;
  }
  toggleLoginPass() {
    if (this.loginPassword) {
      this.loginPassword = false;
    } else {
      this.loginPassword = true;
    }
  }
  loginclickEvent() {
    this.LoginStatus = !this.LoginStatus;
  }
  toggleForgotPass() {
    if (this.forgotPass) {
      this.forgotPass = false;
    } else {
      this.forgotPass = true;
    }
  }
  forgotclickEvent() {
    this.forgotStatus = !this.forgotStatus;
  }
  toggleConfrimForgotPass() {
    if (this.forgotConfirmPass) {
      this.forgotConfirmPass = false;
    } else {
      this.forgotConfirmPass = true;
    }
  }
  ConfrimForgotclickEvent() {
    this.forgotConfirmStatus = !this.forgotConfirmStatus;
  }

  deleteUserAccount(){
    let student: StudentMaster = JSON.parse(
      this.sessionClient.getSession("studentSession")
    );
    this.mainService.deleteUserAccount(student.user.id).subscribe(
      (data) => {
        this.clearSession();
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;
          this.clearSession();
        }
      }
    );
  }
  deleteAccount() {
    this.displayDeleteAccount=true;
    this.close();
    this.activeStateTemp = false;

   
      
    
  }

  private clearSession() {
    localStorage.removeItem("userSession");
    localStorage.removeItem("studentMaster");
    this.sessionClient.signOut();
    this.router.navigateByUrl("/");
    setTimeout(() => {
      //<<<---    using ()=> syntax
      window.location.reload();
    }, 500);
  }
}
